/**
 * Until we have Vue 3, the composition API installation needs to happen (Vue.use...).
 * Once layout components, like the breadcrumb, also uses the composition we need to install
 * the composition as early as possible.
 *
 * We can safely remove this file and its usage after migrating to Vue 3.
 */

import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';

Vue.use(VueCompositionApi);
